
<div class="top-div">

    <div class="login-image-div">
        <img class="login-image" [src]="imgFromApi" alt="Image from API" width="300px" (click)="imageClick()" #loginImg>
        <p class="poem-title">{{poem.title}}</p>
        <p>{{poem.firstLine}}</p>
        <p>{{poem.secondLine}}</p>
    </div>

    <mat-card class="login-card">
        <!--
        <mat-card-header>
            <mat-card-title>{{title}}</mat-card-title>
            <mat-card-subtitle>{{subTitle}}</mat-card-subtitle>
        </mat-card-header>
        -->

        <mat-card-content>
            <form fxLayout="column" fxLayoutAlign="stretch center" [formGroup]="form" (ngSubmit)="submit(form, $event)">
                <mat-form-field class="login-field">
                    <input matInput type="text" placeholder="用户名" formControlName="username">
                    <mat-error>请输入用户名</mat-error>
                </mat-form-field>
                <mat-form-field class="login-field">
                    <input matInput type="password" placeholder="密码" formControlName="password">
                    <mat-error>请输入正确的密码</mat-error>
                </mat-form-field>
                
                <div class="code-div">
                    <mat-form-field class="login-field">
                        <input matInput type="text" placeholder="验证码" formControlName="verificationCode">
                        <mat-error>请输入验证码</mat-error>
                    </mat-form-field>
                    <button mat-raised-button class="code-button" type="button" [disabled]="countdown() > 0" (click)="requireVerificationCode()">
                        @if (countdown() > 0) {
                            {{ countdown() }}秒后重新发送
                        } @else {
                            获取验证码
                        }
                    </button>
                </div>

                <button mat-raised-button class="submit-button" type="submit" [disabled]="!form.valid">登录</button>

            </form>
        </mat-card-content>
        
        <mat-card-footer>
        </mat-card-footer>

    </mat-card>

</div>


